import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import {
  Init,
  Subscriptions,
  Authenticating,
  PaymentResult,
  PaymentsHistory,
  ScheduledPayments,
} from "./pages";

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route exact={true} path="/" component={Init} />
        <Route path="/authenticating" component={Authenticating} />

        <Route path="/subscriptions" component={Subscriptions} />
        <Route path="/payment-result" component={PaymentResult} />
        <Route path="/payments-history" component={PaymentsHistory} />
        <Route path="/scheduled-payments" component={ScheduledPayments} />
      </Switch>
    </Router>
  );
};

export default Routes;
